import { JOURNEY_BUILDER } from 'constants/actionTypes';

export const addStep = payload => ({
  type: JOURNEY_BUILDER.STEPS.ADD,
  payload,
});

export const updateStep = payload => ({
  type: JOURNEY_BUILDER.STEPS.UPDATE,
  payload,
});

export const removeStep = payload => ({
  type: JOURNEY_BUILDER.STEPS.REMOVE,
  payload,
});

export const reorderSteps = payload => ({
  type: JOURNEY_BUILDER.STEPS.REORDER,
  payload,
});

export const showEditDetails = () => ({
  type: JOURNEY_BUILDER.UI.SHOW_EDIT_DETAILS,
});

export const hideEditDetails = () => ({
  type: JOURNEY_BUILDER.UI.HIDE_EDIT_DETAILS,
});

export const updateJourneyDetails = payload => ({
  type: JOURNEY_BUILDER.JOURNEY.UPDATE_DETAILS,
  payload,
});

export const togglePreview = () => ({
  type: JOURNEY_BUILDER.UI.TOGGLE_PREVIEW,
});

export const updateAutosavedAt = payload => ({
  type: JOURNEY_BUILDER.JOURNEY.UPDATE_AUTOSAVE,
  payload,
});
